import {
  Avatar,
  Box,
  Button,
  Card,
  Collapse,
  Dialog,
  FormControl,
  Grid,
  IconButton,
  MenuItem,
  Select,
  Stack,
  Switch,
  Typography,
} from '@mui/material';
import Loading from 'assets/images/loading.png';
import { TaskListCard } from 'component/ExpandedBuyerCard/ExpendedCardDocumentation';
import { useEffect } from 'react';
import { poppins500 } from 'theme/common.style';
const CollapseIcon = () => {
  return (
    <svg
      width="41"
      height="41"
      viewBox="0 0 41 41"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M28 24.0703L20.9289 16.9992L13.8579 24.0703"
        stroke="#0065FC"
        stroke-width="2"
        stroke-linecap="round"
      />
      {/* <rect opacity="0.1" x="0.5" y="0.5" width="40" height="40" rx="4.5" stroke="#112347"/> */}
    </svg>
  );
};
const ExpandIcon = () => {
  return (
    <svg
      width="50"
      height="50"
      viewBox="0 0 41 41"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* <rect opacity="0.1" x="0.5" y="0.5" width="40" height="40" rx="4.5" stroke="#112347" /> */}
      <path
        d="M15.5 17L20.5 22L25.5 17"
        stroke="#0065FC"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

const Emails = ({
  loaderpart,
  sortedCategories,
  handleExpandCollapse,
  expandedCategories,
  buyerId,
  setTaskToEdit,
  taskRefs,
  getTask,
  setIsEdit,
  taskToEdit,
  selectedProperty,
  updateTaskScrollRef,
  value,
  setValue,
  highlightKey,
}) => {
  const formatTimestamp = (timestamp, includeDate = true) => {
    const timestampInMilliseconds = Number(timestamp);

    if (isNaN(timestampInMilliseconds) || !isFinite(timestampInMilliseconds)) {
      return 'Invalid Timestamp';
    }
    const date = new Date(timestampInMilliseconds);
    if (includeDate) {
      const options = {
        day: 'numeric',
        month: 'short',
        hour: 'numeric',
        minute: 'numeric',
        hour12: true,
      };
      return new Intl.DateTimeFormat('en-US', options).format(date);
    } else {
      const options = { hour: 'numeric', minute: 'numeric', hour12: true };
      return new Intl.DateTimeFormat('en-US', options).format(date);
    }
  };

  const formatDueTime = (dueTime) => {
    if (!dueTime) {
      return '';
    }
    const now = new Date().setHours(0, 0, 0, 0);
    const dueDate = new Date(dueTime).setHours(0, 0, 0, 0);

    const diffInDays = Math.floor((dueDate - now) / (24 * 60 * 60 * 1000));

    if (diffInDays === 0) {
      return 'Today';
    } else if (diffInDays === 1) {
      return 'Tomorrow';
    } else if (diffInDays === -1) {
      return 'Yesterday at ' + formatTimestamp(dueTime, false);
    } else {
      return formatTimestamp(dueTime);
    }
  };

  return (
    <Grid conatiner sx={{ width: '100%', marginBottom: '20px' }}>
      {loaderpart ? (
        <Grid sx={{ display: 'flex', justifyContent: 'center', p: '10%' }}>
          <img
            alt="Logo"
            src={Loading}
            className="loaderImage"
            style={{ height: '75px', width: '75px' }}
          />
        </Grid>
      ) : (
        sortedCategories?.map(([category, todos]) => (
          <div key={category} style={{ width: '100%' }}>
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                marginBottom: '10px',
                marginTop: '10px',
                backgroundColor: '#F8F8F8',
              }}
            >
              <Typography
                sx={{
                  fontFamily: 'Poppins',
                  fontWeight: 500,
                  fontSize: '18px',
                  color: '#000000',
                  marginLeft: '15px',
                }}
              >
                {category === 'pending'
                  ? 'Overdue'
                  : category === 'active'
                  ? 'Due'
                  : category === 'completed'
                  ? 'Completed'
                  : category}
              </Typography>
              <IconButton
                onClick={() => handleExpandCollapse(category)}
                disableRipple
              >
                {expandedCategories[category] ? (
                  <CollapseIcon />
                ) : (
                  <ExpandIcon />
                )}
              </IconButton>
            </Box>
            <Collapse in={expandedCategories[category]}>
              {todos.length > 0 ? (
                <Stack direction={'column'} spacing={2} width={'100%'}>
                  {todos.map((todo, index) => {
                    const transId = todo.transobject?.id;
                    const binderId = todo.binder_id;
                    const key = `${binderId}-${transId}`;
                    return (
                      <div key={key} ref={(el) => (taskRefs.current[key] = el)}>
                        <TaskListCard
                          todo={todo}
                          key={index}
                          objectType={
                            todo.transobject
                              ? todo.transobject.type
                              : todo.object_type
                          }
                          addedBy={
                            todo.transobject
                              ? todo.transobject.creator.name
                              : ''
                          }
                          description={
                            todo.transobject
                              ? todo.transobject.sub_title
                              : 'Document E-Sign assigned'
                          }
                          titleName={
                            todo.transobject ? todo.transobject.title : ''
                          }
                          createdTime={formatTimestamp(
                            todo.transobject
                              ? todo.transobject.created_time
                              : ''
                          )}
                          dueTime={formatDueTime(
                            todo.transobject
                              ? todo.transobject.expiration_date
                              : ''
                          )}
                          completed={category === 'completed'}
                          pending={category === 'pending'}
                          selectedProperty={selectedProperty}
                          transId={
                            todo.transobject ? todo.transobject.id : null
                          }
                          binderId={todo.binder_id}
                          buyerId={buyerId}
                          setTaskToEdit={setTaskToEdit}
                          taskToEdit={taskToEdit}
                          setIsEdit={setIsEdit}
                          getTask={getTask}
                          updateTaskScrollRef={updateTaskScrollRef}
                          tabValue={value}
                          setTabValue={setValue}
                          isHighlighted={key === highlightKey}
                        />
                      </div>
                    );
                  })}
                </Stack>
              ) : (
                <Typography
                  sx={{
                    ...poppins500,
                    fontSize: '16px',
                    color: '#585858',
                    marginLeft: '15px',
                  }}
                >
                  {`No ${
                    category === 'completed'
                      ? 'task is completed'
                      : category === 'pending'
                      ? 'pending task available'
                      : 'active task available'
                  }`}
                </Typography>
              )}
            </Collapse>
          </div>
        ))
      )}
    </Grid>
  );
};
export default Emails;
